import { render, staticRenderFns } from "./RoleUserList.vue?vue&type=template&id=a84ce060&scoped=true"
import script from "./RoleUserList.vue?vue&type=script&lang=js"
export * from "./RoleUserList.vue?vue&type=script&lang=js"
import style0 from "./RoleUserList.vue?vue&type=style&index=0&id=a84ce060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84ce060",
  null
  
)

export default component.exports